import { InitialValues } from 'forms/types';

import { WaitingPeriodFormValues, WaitingPeriodValue } from '../form/types';
import { GetSurveyWaitingPeriodQuery } from '../graphql/GetWaitingPeriod';

const buildInitialValues = (
  data?: GetSurveyWaitingPeriodQuery
): InitialValues<WaitingPeriodFormValues> => ({
  waitingPeriod: (data?.surveyWaitingPeriod.waitingPeriod as WaitingPeriodValue) ?? 90,
});

export default buildInitialValues;
